import { render, staticRenderFns } from "./WalletHistorySection.vue?vue&type=template&id=4b5e357a&"
import script from "./WalletHistorySection.vue?vue&type=script&lang=js&"
export * from "./WalletHistorySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports